import { TransfereBeneficioComponent } from './components/portal/administrativo/gestao-beneficios/transfere-beneficio/transfere-beneficio.component';
import { GestorAceitoListComponent } from './components/portal/administrativo/gestor/gestor-aceito-list/gestor-aceito-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './components/login/login-form/login-form.component';
import { LoginPinComponent } from './components/login/login-pin/login-pin.component';
import { RegisterGestorComponent } from './components/register/register-gestor/register-gestor.component';
import { RegisterComponent } from './components/register/register.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/portal/home/home.component';
import { SelectAssignorComponent } from './components/portal/select-assignor/select-assignor.component';
import { NotFoundComponent } from './components/info/not-found/not-found.component';
import { RegisterGestorAccountComponent } from './components/register/register-gestor-account/register-gestor-account.component';
import { RegisterCedenteComponent } from './components/register/register-cedente/register-cedente.component';
import { RegisterEndComponent } from './components/register/register-end/register-end.component';
import { CentroCustoComponent } from './components/portal/cadastro/centro-custo/centro-custo.component';
import { CentroCustoListComponent } from './components/portal/cadastro/centro-custo/centro-custo-list/centro-custo-list.component';
import { PortalComponent } from './components/portal/portal.component';
import { CentroCustoCreateComponent } from './components/portal/cadastro/centro-custo/centro-custo-create/centro-custo-create.component';
import { CentroCustoEditComponent } from './components/portal/cadastro/centro-custo/centro-custo-edit/centro-custo-edit.component';
import { UnidadeComponent } from './components/portal/cadastro/unidade/unidade.component';
import { UnidadeListComponent } from './components/portal/cadastro/unidade/unidade-list/unidade-list.component';
import { UnidadeCreateComponent } from './components/portal/cadastro/unidade/unidade-create/unidade-create.component';
import { UnidadeEditComponent } from './components/portal/cadastro/unidade/unidade-edit/unidade-edit.component';
import { DepartamentoComponent } from './components/portal/cadastro/departamento/departamento.component';
import { DepartamentoListComponent } from './components/portal/cadastro/departamento/departamento-list/departamento-list.component';
import { DepartamentoCreateComponent } from './components/portal/cadastro/departamento/departamento-create/departamento-create.component';
import { DepartamentoEditComponent } from './components/portal/cadastro/departamento/departamento-edit/departamento-edit.component';
//#region Colaborador
import { ColaboradorComponent } from './components/portal/cadastro/colaborador/colaborador.component';
import { ColaboradorListComponent } from './components/portal/cadastro/colaborador/colaborador-list/colaborador-list.component';
import { ColaboradorCreateComponent } from './components/portal/cadastro/colaborador/colaborador-create/colaborador-create.component';
import { ColaboradorEditComponent } from './components/portal/cadastro/colaborador/colaborador-edit/colaborador-edit.component';
import { ColaboradorCartaoComponent } from './components/portal/cadastro/colaborador/colaborador-cartao/colaborador-cartao.component';
import { ColaboradorCartaoLoteComponent } from './components/portal/cadastro/colaborador/colaborador-cartao-lote/colaborador-cartao-lote.component';
import { ColaboradorCreateLoteComponent } from './components/portal/cadastro/colaborador/colaborador-create-lote/colaborador-create-lote.component';
import { ColaboradorCreateArquivoComponent } from './components/portal/cadastro/colaborador/colaborador-create-arquivo/colaborador-create-arquivo.component';
//#endregion
import { RegisterGestorConfirmComponent } from './components/register/register-gestor-confirm/register-gestor-confirm.component';
import { PasswordComponent } from './components/password/password.component';
import { PasswordResetComponent } from './components/password/password-reset/password-reset.component';
import { PasswordConfirmComponent } from './components/password/password-confirm/password-confirm.component';
//#region Gestor
import { GestorComponent } from './components/portal/administrativo/gestor/gestor.component';
import { GestorListComponent } from './components/portal/administrativo/gestor/gestor-list/gestor-list.component';
import { GestorInviteComponent } from './components/portal/administrativo/gestor/gestor-invite/gestor-invite.component';
//#endregion
//#region DadosEmpresa
import { DadoEmpresaComponent } from './components/portal/administrativo/dado-empresa/dado-empresa.component';
import { DadoEmpresaEditComponent } from './components/portal/administrativo/dado-empresa/dado-empresa-edit/dado-empresa-edit.component';
import { DadoEmpresaDetailComponent } from './components/portal/administrativo/dado-empresa/dado-empresa-detail/dado-empresa-detail.component';
import { DadoEmpresaInfoCadastraisComponent } from './components/portal/administrativo/dado-empresa/dado-empresa-detail/dado-empresa-info-cadastrais/dado-empresa-info-cadastrais.component';
//#endregion
//#region DadosBancario
import { DadoBancarioComponent } from './components/portal/administrativo/dado-bancario/dado-bancario.component';
import { DadoBancarioListComponent } from './components/portal/administrativo/dado-bancario/dado-bancario-list/dado-bancario-list.component';
import { DadoBancarioCreateComponent } from './components/portal/administrativo/dado-bancario/dado-bancario-create/dado-bancario-create.component';
import { DadoBancarioEditComponent } from './components/portal/administrativo/dado-bancario/dado-bancario-edit/dado-bancario-edit.component';
//#endregion
import { AccessDeniedComponent } from './components/info/access-denied/access-denied.component';
//#region Guards
import { AuthGuard } from './shared/helpers/guards/auth.guard';
import { CadastroGuard } from './shared/helpers/guards/cadastro.guard';
import { AdministrativoGuard } from './shared/helpers/guards/administrativo.guard';
import { ProdutoGuard } from './shared/helpers/guards/produto.guard';
import { PedidoGuard } from './shared/helpers/guards/pedido.guard';
import { FinanceiroGuard } from './shared/helpers/guards/financeiro.guard';
//#endregion
//#region novoBeneficio
import { NovoBeneficioComponent } from './components/portal/produtos/novo-beneficio/novo-beneficio.component';
import { NovoBeneficioContratarComponent } from './components/portal/produtos/novo-beneficio/novo-beneficio-contratar/novo-beneficio-contratar.component';
//#endregion

//#region novacompra
import { NovacompraComponent } from './components/portal/compras/nova-compra/nova-compra.component';
import { NovacompraCreateComponent } from './components/portal/compras/nova-compra/nova-compra-create/nova-compra-create.component';
import { NovacompraPeriodoComponent } from './components/portal/compras/nova-compra/nova-compra-periodo/nova-compra-periodo.component';
import { NovacompraColaboradorComponent } from './components/portal/compras/nova-compra/nova-compra-colaborador/nova-compra-colaborador.component';
import { NovacompraConfirmarComponent } from './components/portal/compras/nova-compra/nova-compra-confirmar/nova-compra-confirmar.component';
import { NovacompraPagamentoComponent } from './components/portal/compras/nova-compra/nova-compra-pagamento/nova-compra-pagamento.component';
import { NovacompraGrupoColaboradorComponent} from './components/portal/compras/nova-compra/nova-compra-grupo-colaborador/nova-compra-grupo-colaborador.component';
//#endregion
//#region minhasCompras
import { MinhasComprasComponent } from './components/portal/compras/minhas-compras/minhas-compras.component';
import { MinhasComprasListComponent } from './components/portal/compras/minhas-compras/minhas-compras-list/minhas-compras-list.component';
import { MinhasComprasDetailsComponent } from './components/portal/compras/minhas-compras/minhas-compras-details/minhas-compras-details.component';
//#endregion

//#region contratos
import { ContratoComponent } from './components/portal/produtos/contrato/contrato.component';
import { ContratosListComponent } from './components/portal/produtos/contrato/contratos-list/contratos-list.component';
import { GestaoBeneficiosComponent } from './components/portal/administrativo/gestao-beneficios/gestao-beneficios.component';
import { GestorEditComponent } from './components/portal/administrativo/gestor/gestor-edit/gestor-edit.component';
import { ColaboradorVincularQrLoteComponent } from './components/portal/cadastro/colaborador/colaborador-vincular-qr-lote/colaborador-vincular-qr-lote.component';
import { NovacompraArquivoComponent } from './components/portal/compras/nova-compra/nova-compra-arquivo/nova-compra-arquivo.component';
//#endregion
import { ColaboradorFinanceiroListComponent } from './components/portal/administrativo/gestao-beneficios/colaborador-financeiro-list/colaborador-financeiro-list.component';
import { ResgateBeneficioComponent } from './components/portal/administrativo/gestao-beneficios/resgate-beneficio/resgate-beneficio.component';
import { PagamentosComponent } from './components/portal/financeiro/pagamentos/pagamentos.component';
import { PagamentosListComponent } from './components/portal/financeiro/pagamentos/pagamentos-list/pagamentos-list.component';
import { ExtratoCompraComponent } from './components/portal/financeiro/extrato-pedido/extrato-compra.component';
import { ExtratoCompraListComponent } from './components/portal/financeiro/extrato-pedido/extrato-compra-list/extrato-compra-list.component';
import { DepositosComponent } from './components/portal/financeiro/depositos/depositos.component';
import { TipoDepositoComponent } from './components/portal/financeiro/depositos/tipo-deposito/tipo-deposito.component';
import { TransferenciaComponent } from './components/portal/financeiro/depositos/transferencia/transferencia.component';
import { BoletoComponent } from './components/portal/financeiro/depositos/boleto/boleto.component';
import { VisualizarBoletoComponent } from './components/portal/visualizar-boleto/visualizar-boleto.component';
import { DepositosPagamentosComponent } from './components/portal/financeiro/depositos-pagamentos/depositos-pagamentos.component';
import { ColaboradorBeneficiosComponent } from './components/portal/cadastro/colaborador/colaborador-beneficios/colaborador-beneficios.component';
import { GrupoComponent } from './components/portal/cadastro/grupo/grupo.component';
import { GrupoListComponent } from './components/portal/cadastro/grupo/grupo-list/grupo-list.component';
import { GrupoCreateComponent } from './components/portal/cadastro/grupo/grupo-create/grupo-create.component';
import { GrupoAddCollaboratorComponent } from './components/portal/cadastro/grupo/grupo-add-collaborator/grupo-add-collaborator.component';
import { GrupoListCollaboratorComponent } from './components/portal/cadastro/grupo/grupo-list-collaborator/grupo-list-collaborator.component';
import { GrupoBeneficiosComponent } from './components/portal/cadastro/grupo/grupo-beneficios/grupo-beneficios.component';
import { GrupoRegrasComponent } from './components/portal/cadastro/grupo/grupo-regras/grupo-regras.component';
import { GrupoResumoComponent } from './components/portal/cadastro/grupo/grupo-resumo/grupo-resumo.component';
import { GrupoDetalheComponent } from './components/portal/cadastro/grupo/grupo-detalhe/grupo-detalhe.component';
import { NovacompraGrupoComponent } from './components/portal/compras/nova-compra/nova-compra-grupo/nova-compra-grupo.component';
import { CartaoComponent } from './components/portal/financeiro/cartao/cartao.component';
import { CartaoStatusListComponent } from './components/portal/financeiro/cartao/cartao-status-list/cartao-status-list.component';
import { ExtratoComponent } from './components/portal/financeiro/extrato/extrato.component';
import { ExtratoListComponent } from './components/portal/financeiro/extrato/extrato-list/extrato-list.component';
import { DepositosPagamentosListComponent } from './components/portal/financeiro/depositos-pagamentos/depositos-pagamentos-list/depositos-pagamentos-list.component';
import { DepositosCreateComponent } from './components/portal/financeiro/depositos-pagamentos/depositos-create/depositos-create.component';
import { svgCard } from './shared/components/svgCard/svg-card';
import { NotificacaoListComponent } from './components/portal/notificacao/notificacao-list/notificacao-list.component';
import { NotificacaoComponent } from './components/portal/notificacao/notificacao.component';
import { RelatorioComponent } from './components/portal/relatorio/relatorio.component';
import { RelatorioFavorecidoComponent } from './components/portal/relatorio/relatorio-favorecido/relatorio-favorecido.component';
import { FavorecidoConsolidadaComponent } from './components/portal/relatorio/favorecido-consolidada/favorecido-consolidada.component';
import { SaldoDetalhadoComponent } from './components/portal/relatorio/saldo-detalhado/saldo-detalhado.component';
import { SaldoConsolidadoComponent } from './components/portal/relatorio/saldo-consolidado/saldo-consolidado.component';
import { ExtratoRelatorioComponent } from './components/portal/relatorio/extrato-relatorio/extrato-relatorio.component';
import { ColaboradorVincularCartaoComponent } from './components/portal/cadastro/colaborador/colaborador-vincular-cartao/colaborador-vincular-cartao.component';
import { ColaboradorVincularCartaoFormComponent } from './components/portal/cadastro/colaborador/colaborador-vincular-cartao/colaborador-vincular-cartao-form/colaborador-vincular-cartao-form.component';
import { ColaboradorVincularCartaoInfoComponent } from './components/portal/cadastro/colaborador/colaborador-vincular-cartao/colaborador-vincular-cartao-info/colaborador-vincular-cartao-info.component';
import { CreditoRelatorioComponent } from './components/portal/relatorio/credito-relatorio/credito-relatorio.component';
import { RecargasRelatorioComponent } from './components/portal/relatorio/recargas-relatorio/recargas-relatorio.component';
import { SituacaoCadastroComponent } from './components/portal/relatorio/situacao-cadastro/situacao-cadastro.component';
import { SituacaoCartaoComponent } from './components/portal/relatorio/situacao-cartao/situacao-cartao.component';
import { CartoesFisicosComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos.component';
import { CartoesFisicosGuard } from './shared/helpers/guards/cartoes-fisicos.guard';
import { CartoesFisicosPedidoComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-pedido/cartoes-fisicos-pedido.component';
import { CartoesFisicosListComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-list/cartoes-fisicos-list.component';
import { CartoesFisicosPedidoDetalhesComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-pedido-detalhes/cartoes-fisicos-pedido-detalhes.component';
import { RelatorioGuard } from './shared/helpers/guards/relatorio.guard';
import { SituacaoSolicitacaoCartaoComponent } from './components/portal/relatorio/situacao-solicitacao-cartao/situacao-solicitacao-cartao.component';
import { ResetarSenhaComponent } from './components/portal/resetar-senha/resetar-senha.component';
import { DadoEmpresaEnderecoComponent } from './components/portal/administrativo/dado-empresa/dado-empresa-detail/dado-empresa-endereco/dado-empresa-endereco.component';
import { VeiculosComponent } from './components/portal/cadastro/veiculos/veiculos.component';
import { VeiculosCreateComponent } from './components/portal/cadastro/veiculos/veiculos-create/veiculos-create.component';
import { VeiculosListComponent } from './components/portal/cadastro/veiculos/veiculos-list/veiculos-list.component';
import { VeiculosEditComponent } from './components/portal/cadastro/veiculos/veiculos-edit/veiculos-edit.component';
import { VeiculosCondutoresComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores.component';
import { VeiculosCondutoresListComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores-list/veiculos-condutores-list.component';
import { VeiculosCondutoresAddComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores-add/veiculos-condutores-add.component';
import { VeiculosVincularCartaoComponent } from './components/portal/cadastro/veiculos/veiculos-vincular-cartao/veiculos-vincular-cartao.component';
import { SaldoAlocadoComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado.component';
import { SaldoAlocadoListComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-list/saldo-alocado-list.component';
import { SaldoAlocadoCreateComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-create/saldo-alocado-create.component';
import { CondutorComponent } from './components/portal/cadastro/condutor/condutor.component';
import { CondutorListComponent } from './components/portal/cadastro/condutor/condutor-list/condutor-list.component';
import { CondutorEditComponent } from './components/portal/cadastro/condutor/condutor-edit/condutor-edit.component';
import { CondutorCreateComponent } from './components/portal/cadastro/condutor/condutor-create/condutor-create.component';
import { SaldoAlocadoEditComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-edit/saldo-alocado-edit.component';
import { ExtratoLogListComponent } from './components/portal/financeiro/extrato-log/extrato-log-list/extrato-log-list.component';
import { ExtratoLogComponent } from './components/portal/financeiro/extrato-log/extrato-log.component';
import { RelatorioLogComponent } from './components/portal/relatorio-log/relatorio-log.component';
import { ValidadeCnhComponent } from './components/portal/relatorio-log/validade-cnh/validade-cnh.component';
import { ConsumoComponent } from './components/portal/relatorio-log/consumo/consumo.component';
import { ColaboradorArquivoConfirmarComponent } from './components/portal/cadastro/colaborador/colaborador-arquivo-confirmar/colaborador-arquivo-confirmar.component';
import { NovacompraArquivoConfirmarComponent } from './components/portal/compras/nova-compra/nova-compra-arquivo-confirmar/nova-compra-arquivo-confirmar.component';
import { PortadorVincularCartaoComponent } from './components/portal/cadastro/portador/portador-vincular-cartao/portador-vincular-cartao.component';
import { TransacaoSaldoAlocadoComponent } from './components/portal/relatorio-despesas/transacao-saldo-alocado/transacao-saldo-alocado.component';
import { RelatorioDespesasComponent } from './components/portal/relatorio-despesas/relatorio-despesas.component';
import { CreditosComponent } from './components/portal/relatorio-despesas/creditos/creditos.component';
//#endregion

const routes: Routes = [
    { path: '', redirectTo: 'portal', pathMatch: 'full' },
    {
        path: 'auth', component: LoginComponent,
        children: [
            { path: '', redirectTo: 'form', pathMatch: 'full' },
            { path: 'form', component: LoginFormComponent },
            { path: 'pin', component: LoginPinComponent, data: { email: '' } }
        ]
    },
    {
        path: 'register', component: RegisterComponent,
        children: [
            { path: '', redirectTo: 'gestor', pathMatch: 'full' },
            { path: 'gestor', component: RegisterGestorComponent },
            { path: 'gestor-account', component: RegisterGestorAccountComponent },
            { path: 'gestor-confirm', component: RegisterGestorConfirmComponent },
            { path: 'cedente', component: RegisterCedenteComponent },
            { path: 'end', component: RegisterEndComponent }
        ]
    },
    {
        path: 'password', component: PasswordComponent,
        children: [
            { path: '', redirectTo: 'reset', pathMatch: 'full' },
            { path: 'reset', component: PasswordResetComponent },
            { path: 'confirm', component: PasswordConfirmComponent }
        ]
    },
    {
        path: 'portal', component: PortalComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            {
                path: 'notificacao', component: NotificacaoComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'notificacao-list', component: NotificacaoListComponent }
                ]
            },
            {
                path: 'centrocusto', component: CentroCustoComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: CentroCustoListComponent },
                    { path: 'create', component: CentroCustoCreateComponent },
                    { path: 'edit/:id', component: CentroCustoEditComponent }
                ]
            },
            {
                path: 'unidade', component: UnidadeComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: UnidadeListComponent },
                    { path: 'create', component: UnidadeCreateComponent },
                    { path: 'edit/:id', component: UnidadeEditComponent }
                ]
            },
            {
                path: 'departamento', component: DepartamentoComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: DepartamentoListComponent },
                    { path: 'create', component: DepartamentoCreateComponent },
                    { path: 'edit/:id', component: DepartamentoEditComponent }
                ]
            },
            {
                path: 'veiculos', component: VeiculosComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: VeiculosListComponent },
                    { path: 'create', component: VeiculosCreateComponent },
                    { path: 'edit/:id', component: VeiculosEditComponent },
                    {
                        path: 'conductors', component: VeiculosCondutoresComponent,
                        children: [
                            { path: '', redirectTo: 'list', pathMatch: 'full' },
                            { path: 'list', component: VeiculosCondutoresListComponent },
                            { path: 'add', component: VeiculosCondutoresAddComponent }
                        ]
                    },
                    { path: 'bind-card', component: VeiculosVincularCartaoComponent },
                ]

            },
            {
                path: 'colaborador', component: ColaboradorComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: ColaboradorListComponent },
                    { path: 'create', component: ColaboradorCreateComponent },
                    { path: 'create-lote', component: ColaboradorCreateLoteComponent },
                    { path: 'list/:id', component: ColaboradorListComponent },
                    { path: 'edit/:id', component: ColaboradorEditComponent },
                    { path: 'cartao/:colaboradorId', component: ColaboradorCartaoComponent },
                    { path: 'cartao-lote', component: ColaboradorCartaoComponent },
                    { path: 'beneficios/:colaboradorId', component: ColaboradorBeneficiosComponent },
                    { path: 'vincular-qr-lote', component: ColaboradorVincularQrLoteComponent },
                    { path: 'create-arquivo', component: ColaboradorCreateArquivoComponent },
                    { path: 'arquivo-confimar/:id', component: ColaboradorArquivoConfirmarComponent },
                    { path: 'vincular-cartao', component: ColaboradorVincularCartaoComponent,
                        children: [
                            {path: '', component: DepositosPagamentosListComponent},
                            {path: '', component: DepositosCreateComponent}
                        ]
                    },
                    { path: 'vincular-cartao-portador/:id', component: PortadorVincularCartaoComponent },
                ]
            },
            {
                path: 'condutor', component: CondutorComponent, canActivate: [CadastroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: CondutorListComponent },
                    { path: 'edit/:id', component: CondutorEditComponent },
                    { path: 'create', component: CondutorCreateComponent },
                ]
            },
            {
                path: 'grupos', component: GrupoComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: GrupoListComponent },
                    { path: 'create', component: GrupoCreateComponent },
                    { path: 'collaborator', component: GrupoAddCollaboratorComponent },
                    { path: 'list-collaborator', component: GrupoListCollaboratorComponent },
                    { path: 'beneficios', component: GrupoBeneficiosComponent },
                    { path: 'regras', component: GrupoRegrasComponent },
                    { path: 'resumo', component: GrupoResumoComponent },
                    { path: 'detalhe', component: GrupoDetalheComponent }
                ]
            },
            {
                path: 'gestor', component: GestorComponent, canActivate: [AdministrativoGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: GestorListComponent },
                    { path: 'list-accepted', component: GestorAceitoListComponent },
                    { path: 'invite', component: GestorInviteComponent },
                    { path: 'edit/:id', component: GestorEditComponent },
                ]
            },
            {
                path: 'gestao-beneficio', component: GestaoBeneficiosComponent, canActivate: [AdministrativoGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: ColaboradorListComponent },
                    { path: 'resgate/:colaboradorID', component: ResgateBeneficioComponent },
                    { path: 'transfere-beneficio/:colaboradorID', component: TransfereBeneficioComponent }
                ]
            },
            {
                path: 'dadoempresa', component: DadoEmpresaComponent,
                children: [
                    { path: '', redirectTo: 'detail', pathMatch: 'full' },
                    { path: 'detail', component: DadoEmpresaDetailComponent,
                        children: [
                            {path: '', component: DadoEmpresaInfoCadastraisComponent},
                            {path: '', component: DadoEmpresaEnderecoComponent},
                    ]
                },
                    { path: 'edit', component: DadoEmpresaEditComponent }
                ]
            },
            {
                path: 'dadobancario', component: DadoBancarioComponent, canActivate: [AdministrativoGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: DadoBancarioListComponent },
                    { path: 'create', component: DadoBancarioCreateComponent },
                    { path: 'edit', component: DadoBancarioEditComponent }
                ]
            },
            {
                path: 'novobeneficio', component: NovoBeneficioComponent, canActivate: [ProdutoGuard],
                children: [
                    { path: '', redirectTo: 'contratar', pathMatch: 'full' },
                    { path: 'contratar', component: NovoBeneficioContratarComponent }
                ]
            },
            {
                path: 'novarecarga', component: NovacompraComponent, canActivate: [PedidoGuard],
                children: [
                    { path: '', redirectTo: 'create', pathMatch: 'full' },
                    { path: 'create', component: NovacompraCreateComponent },
                    { path: 'selecionarcolaborador', component: NovacompraColaboradorComponent },
                    { path: 'selecaoperiodo', component: NovacompraPeriodoComponent },
                    { path: 'confirmarrecarga', component: NovacompraConfirmarComponent },
                    { path: 'pagamento', component: NovacompraPagamentoComponent },
                    { path: 'grupo', component: NovacompraGrupoComponent },
                    { path: 'arquivo', component: NovacompraArquivoComponent },
                    { path: 'arquivo-confimar/:id', component: NovacompraArquivoConfirmarComponent },
                    { path: 'selecionargrupocolaborador', component: NovacompraGrupoColaboradorComponent}
                ]
            },
            {
                path: 'minhasrecargas', component: MinhasComprasComponent, canActivate: [PedidoGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: MinhasComprasListComponent },
                    { path: 'details/:id', component: MinhasComprasDetailsComponent }
                ]
            },
            {
                path: 'contrato', component: ContratoComponent, canActivate: [ProdutoGuard],
                children: [
                    { path: '', redirectTo: 'contratos', pathMatch: 'full' },
                    { path: 'contratos', component: ContratosListComponent }
                ]

            },
            {
                path: 'pagamentos', component: PagamentosComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: PagamentosListComponent }
                ]
            },
            {
                path: 'extrato-compra', component: ExtratoCompraComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: ExtratoCompraListComponent }
                ]
            },
            {
                path: 'extrato', component: ExtratoComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: ExtratoListComponent }
                ]
            },
            {
                path: 'extrato-log', component: ExtratoLogComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: ExtratoLogListComponent },
                ]
            },
            {
                path: 'deposito', component: DepositosComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'tipo', pathMatch: 'full' },
                    { path: 'tipo', component: TipoDepositoComponent },
                    { path: 'transferencia', component: TransferenciaComponent },
                    { path: 'boleto', component: BoletoComponent }
                ]
            },
            {
                path: 'depositos-pagamentos', component: DepositosPagamentosComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', children: [
                            {path: '', component: DepositosPagamentosListComponent},
                            {path: '', component: DepositosCreateComponent}
                        ]
                    },
                    { path: 'list/:id', children: [
                        {path: '', component: DepositosPagamentosListComponent},
                        {path: '', component: DepositosCreateComponent}
                    ]
                },
                    { path: 'transferencia', component: TransferenciaComponent },
                    { path: 'boleto', component: BoletoComponent }
                ]
            },
            {
                path: 'boleto', component: VisualizarBoletoComponent, canActivate: [FinanceiroGuard],
            },
            {
                path: 'cartao', component: CartaoComponent, canActivate: [FinanceiroGuard],
                children: [
                    { path: '', redirectTo: 'status-list', pathMatch: 'full' },
                    { path: 'status-list', component: CartaoStatusListComponent }
                ]
            },
            {
                path: 'relatorio', component: RelatorioComponent, canActivate: [RelatorioGuard],
                children: [
                    // { path: '', redirectTo: 'status-list', pathMatch: 'full' },
                    { path: 'relatorio-favorecido', component: RelatorioFavorecidoComponent },
                    { path: 'favorecido-consolidada', component: FavorecidoConsolidadaComponent },
                    { path: 'saldo-detalhado', component: SaldoDetalhadoComponent },
                    { path: 'saldo-consolidado', component: SaldoConsolidadoComponent },
                    { path: 'extrato-relatorio', component: ExtratoRelatorioComponent },
                    { path: 'credito-relatorio', component: CreditoRelatorioComponent },
                    { path: 'recargas-relatorio', component: RecargasRelatorioComponent },
                    { path: 'situacao-cadastro', component: SituacaoCadastroComponent },
                    { path: 'situacao-cartao', component: SituacaoCartaoComponent },
                    { path: 'solicitacao-cartao', component: SituacaoSolicitacaoCartaoComponent }
                ]
            },
            {
                path: 'relatorio-log', component: RelatorioLogComponent,
                children: [
                    // { path: '', redirectTo: 'status-list', pathMatch: 'full' },
                    { path: 'validade-cnh', component: ValidadeCnhComponent },
                    { path: 'consumo', component: ConsumoComponent },
                ]
            },
            {
                path: 'relatorio-despesas', component: RelatorioDespesasComponent,
                children: [
                    // { path: '', redirectTo: 'status-list', pathMatch: 'full' },
                    { path: 'transacoes', component: TransacaoSaldoAlocadoComponent },
                    { path: 'creditos', component: CreditosComponent }
                ],
            },
            
            //adicionar Guard
            {
                path: 'cartoes', component: CartoesFisicosComponent, canActivate: [CartoesFisicosGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: CartoesFisicosListComponent },
                    { path: 'novopedido', component: CartoesFisicosPedidoComponent },
                    { path: 'pedidodetalhes/:id', component: CartoesFisicosPedidoDetalhesComponent }
                ]
            },
            { path: 'redefinir-senha', component: ResetarSenhaComponent},
            {
                path: 'saldo-alocado', component: SaldoAlocadoComponent, canActivate: [CartoesFisicosGuard],
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: SaldoAlocadoListComponent },
                    { path: 'create', component: SaldoAlocadoCreateComponent },
                    { path: 'edit/:id', component: SaldoAlocadoEditComponent },
                ]
            },
        ]
    },
    { path: 'selectassignor', component: SelectAssignorComponent, canActivate: [AuthGuard] },
    { path: 'accessdenied', component: AccessDeniedComponent },
    { path: '**', component: NotFoundComponent }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

export const RoutingComponents = [
    LoginComponent,
    LoginFormComponent,
    LoginPinComponent,
    RegisterComponent,
    RegisterGestorComponent,
    RegisterGestorAccountComponent,
    RegisterCedenteComponent,
    RegisterEndComponent,
    HomeComponent,
    SelectAssignorComponent,
    CentroCustoComponent,
    CentroCustoListComponent,
    CentroCustoCreateComponent,
    CentroCustoEditComponent,
    PortalComponent,
    UnidadeComponent,
    UnidadeListComponent,
    UnidadeCreateComponent,
    UnidadeEditComponent,
    DepartamentoComponent,
    DepartamentoListComponent,
    DepartamentoCreateComponent,
    DepartamentoEditComponent,
    ColaboradorComponent,
    ColaboradorListComponent,
    ColaboradorCreateComponent,
    ColaboradorEditComponent,
    ColaboradorCartaoComponent,
    ColaboradorCartaoLoteComponent,
    ColaboradorVincularCartaoComponent,
    ColaboradorVincularCartaoFormComponent,
    ColaboradorVincularCartaoInfoComponent,
    ColaboradorCreateLoteComponent,
    ColaboradorVincularQrLoteComponent,
    ColaboradorCreateArquivoComponent,
    RegisterGestorConfirmComponent,
    PasswordComponent,
    PasswordResetComponent,
    PasswordConfirmComponent,
    LoginComponent,
    RegisterComponent,
    GestorComponent,
    GestorListComponent,
    GestorInviteComponent,
    GestorEditComponent,
    DadoEmpresaComponent,
    DadoEmpresaEditComponent,
    DadoEmpresaDetailComponent,
    DadoEmpresaInfoCadastraisComponent,
    DadoEmpresaEnderecoComponent,
    DadoBancarioComponent,
    DadoBancarioListComponent,
    DadoBancarioCreateComponent,
    DadoBancarioEditComponent,
    NotFoundComponent,
    AccessDeniedComponent,
    NovoBeneficioComponent,
    NovoBeneficioContratarComponent,
    MinhasComprasComponent,
    MinhasComprasListComponent,
    MinhasComprasDetailsComponent,
    NovacompraComponent,
    NovacompraCreateComponent,
    NovacompraColaboradorComponent,
    NovacompraConfirmarComponent,
    NovacompraPeriodoComponent,
    NovacompraPagamentoComponent,
    ContratoComponent,
    ContratosListComponent,
    NovacompraArquivoComponent,
    PagamentosComponent,
    PagamentosListComponent,
    NovacompraGrupoColaboradorComponent,
    ExtratoComponent,
    ExtratoListComponent,
    DepositosPagamentosComponent,
    DepositosPagamentosListComponent,
    DepositosCreateComponent,
    svgCard,
    NotificacaoComponent,
    NotificacaoListComponent,
    RelatorioComponent,
    RelatorioFavorecidoComponent,
    FavorecidoConsolidadaComponent,
    SaldoDetalhadoComponent,
    SaldoConsolidadoComponent,
    ExtratoRelatorioComponent,
    CreditoRelatorioComponent,
    RecargasRelatorioComponent,
    SituacaoCadastroComponent,
    SituacaoCartaoComponent,
    CartoesFisicosComponent,
    CartoesFisicosPedidoComponent,
    CartoesFisicosPedidoDetalhesComponent,
    SituacaoSolicitacaoCartaoComponent,
    TransacaoSaldoAlocadoComponent,
    CreditosComponent,
    ResetarSenhaComponent,
    VeiculosComponent,
    VeiculosListComponent,
    VeiculosCreateComponent,
    VeiculosEditComponent,
    VeiculosCondutoresComponent,
    VeiculosCondutoresListComponent,
    VeiculosCondutoresAddComponent,
    SaldoAlocadoComponent,
    SaldoAlocadoListComponent,
    SaldoAlocadoCreateComponent,
    SaldoAlocadoEditComponent,
    CondutorComponent,
    CondutorListComponent,
    CondutorEditComponent,
    CondutorCreateComponent,
    ExtratoLogComponent,
    ExtratoLogListComponent,
    RelatorioLogComponent,
    RelatorioDespesasComponent,
    ValidadeCnhComponent,
    ConsumoComponent,
    ColaboradorArquivoConfirmarComponent,
    NovacompraArquivoConfirmarComponent
];
